module.exports = __webpack_public_path__ + "img/dropsmith-logo-old.254c6e39.png";